module.exports = __webpack_public_path__ + "static/img/correlation.e4774b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/correlation.png
// module id = zAjp
// module chunks = 1